import { useTranslation } from "react-i18next";

interface Props {
  tenantName: string;
  activeSubjectCount: number;
}

export function ProjectOverviewStrip({
  tenantName,
  activeSubjectCount,
}: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <section
      className="rounded-2xl border border-slate-200 bg-white p-4 md:p-5"
      aria-label={t("dashboard.reviewConsole.strip.tenantLabel")}
    >
      <div className="flex flex-wrap items-baseline gap-x-6 gap-y-2">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500">
            {t("dashboard.reviewConsole.strip.tenantLabel")}
          </p>
          <p className="mt-1 text-base font-semibold text-white">
            {tenantName}
          </p>
        </div>
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500">
            {t("dashboard.reviewConsole.strip.configuredFor")}
          </p>
          <p className="mt-1 text-sm text-slate-600">
            {t("dashboard.reviewConsole.strip.subjectsActive", {
              count: activeSubjectCount,
            })}
          </p>
        </div>
        <div className="w-full sm:ml-auto sm:w-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-blue-200 bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-600">
            <span className="h-1.5 w-1.5 rounded-full bg-blue-600" aria-hidden="true" />
            {t("dashboard.reviewConsole.strip.ready")}
          </span>
          <p className="mt-1.5 text-[11px] text-slate-500">
            {t("dashboard.reviewConsole.strip.readyHint")}
          </p>
        </div>
      </div>
    </section>
  );
}
